import React from "react";
import { motion } from "framer-motion"

const Error: React.FC = () => {

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
      className="flex bg-white">
      <h1 className="align-right align-left mt-35 mb-35">ERROR 404</h1>
    </motion.div>
  );
};

export default Error;
